module.exports = __webpack_public_path__ + "static/media/17-brain.c44ea663.svg";